import Vue from 'vue';
import {Component, Watch} from 'vue-property-decorator';
import 'vue-js-modal';
// import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
// @ts-ignore
import vClickOutside from 'v-click-outside';
import {MD} from '../global_vars';
import Event from '../utils/Event';
import {delay} from '../utils/async';
import {ResizeAF} from '../utils/ResizeAF';
import FormRequestKP from "../components/form/FormRequestKP";
import BranchRequestModal from "../components/bmod/BranchRequestModal";
import BranchChoseModal from "../components/bmod/BranchChoseModal";
import {smoothScrollTo} from "../utils/miscellanea";

const historyStateMenuOpen = 'header-menu-opened';


@Component
export class VMMenu extends Vue {
  openMenu = false;
  itVis = [false, false, false, false, false, false];

  mounted(): void {
    Event.listen('close-menu', () => {
      this.openMenu = false;
    });

    this.showMenu();

    if (!MD.mobile()) {
      setTimeout(() => {
        this.setHidingMenuOnScroll();
      }, 1000);
    }

    // @ts-ignore
    // if (window.gBranchId) {
    //   this.$modal.show(BranchRequestModal,
    //     {},
    //     {
    //       height: 'auto', width: '100%', maxWidth: 966, adaptive: true, scrollable: true,
    //       transition: 'nice-modal-fade',
    //     },
    //   );
    // }

    Event.listen('open-branch-chose-modal', () => {
      this.$modal.show(BranchChoseModal,
        {},
        {
          height: 'auto', width: '100%', maxWidth: 966, adaptive: true, scrollable: true,
          transition: 'nice-modal-fade',
        },
      );
    });
  }

  scrollTo(selector: string) {
    smoothScrollTo(selector);
  }

  async showMenu() {
    await delay(750);
    this.itVis = [false, true, false, false, false, false];
    await delay(100);
    this.itVis = [false, true, false, true, false, false];
    await delay(100);
    this.itVis = [false, true, false, true, true, false];
    await delay(100);
    this.itVis = [true, true, false, true, true, false];
    await delay(100);
    this.itVis = [true, true, true, true, true, true];
  }

  @Watch('openMenu')
  async onOpenMenuChange(val: boolean) {

    Event.fire('menu-open-state', val);

    if (MD.mobile()) {
      if (val) {
        // disableBodyScroll(<HTMLElement>this.$refs.menu_holder);

        history.pushState(historyStateMenuOpen, 'null', null);
        window.addEventListener('popstate', this.onPopStateMenu);
      } else {
        // enableBodyScroll(<HTMLElement>this.$refs.menu_holder);
        window.removeEventListener('popstate', this.onPopStateMenu);

        if (history.state == historyStateMenuOpen) history.back();
      }
    } else {
      if (val) {
        window.addEventListener('scroll', this.onScroll);
      } else {
        window.removeEventListener('scroll', this.onPopStateMenu);
      }
    }
  }

  toggleMenu(): void {
    this.openMenu = !this.openMenu;
  }

  private setHidingMenuOnScroll() {
    let prevScrollpos = window.pageYOffset;

    ResizeAF.instance().onScroll((currentScrollPos) => {
      if (prevScrollpos > currentScrollPos) {
        // @ts-ignore
        this.$el.style.transform = 'translateY(0)';
      } else {
        // @ts-ignore
        this.$el.style.transform = 'translateY(-150px)';
      }

      prevScrollpos = currentScrollPos;
    });
  }

  private onPopStateMenu(): void {
    this.openMenu = false;
  }

  private onScroll(): void {
    this.openMenu = false;
  }
}

@Component({
  directives: {
    clickOutside: vClickOutside.directive
  }
})
export class VMFlMenu extends Vue {
  openMenu = false;
  staticMenu = false;

  mounted() {
    Event.listen('menu-open-state', async (val) => {
      this.openMenu = val;

      if (val) {
        if (window.matchMedia('(max-width: 400px)').matches) {
          await delay(250);
          document.body.classList.add('site--menu-phone');
          this.staticMenu = true;

          requestAnimationFrame(() => {
            document.documentElement.scrollTop = 0;
            document.body.scrollTop = 0;
          });
        }
      } else {
        if (window.matchMedia('(max-width: 400px)').matches) {
          document.body.classList.remove('site--menu-phone');
          this.staticMenu = false;
        }
      }
    });
  }

  onClickOutside(e: MouseEvent): void {
    const target = <HTMLElement>(e.target);
    if (target.classList.contains('menu__sndw')) return;

    Event.fire('close-menu');
    // alert('1');
    this.openMenu = false;
  }

  async scrollTo(selector: string) {
    Event.fire('close-menu');
    this.openMenu = false;
    await delay(100);

    smoothScrollTo(selector, true);
  }
}
